import React, { useState } from "react";

import TodoNew from "./TodoNew";
import TodoHeader from "./TodoHeader";
import TodoContent from "./TodoContent";

const Todo = props => {
  const [open, setOpen] = useState(true);
  const isOpen = open ? "todo--open" : "";
  const classes = "border-right todo " + isOpen;

  return (
    <div className={classes.trim()}>
      <TodoHeader open={open} setOpen={setOpen} />
      <TodoNew />
      <TodoContent />
    </div>
  );
}

export default Todo;